<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="RII上传面单" width="800">
      <el-form :inline="false"  class="" style="text-align: left">
        <el-form-item  label="RII出库单号">
          <el-input style="width:200px" disabled v-model="formInline.riiNumber" ></el-input>
        </el-form-item>
        <el-form-item v-if="formInline.sendChannel=='shopify'" label="物流渠道">
          <el-select
              style="width:200px"
              v-model="formInline.channel"
              clearable
              filterable
              allow-create
              placeholder="请选择平台状态"
          >
            <el-option
                v-for="item in channelList"
                :key="item.myLogisticsId"
                :label="item.myLogisticsChannelName"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item  label="运单号">
          <el-input style="width:200px" v-model="formInline.trackNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="外箱贴文件">
          <el-upload
              ref="packingLableUrl"
              v-model:file-list="packingLableUrl"
              class="upload-demo"
              :action="uploadUrl"
              :on-preview="handlePreview"
              :on-success="handlePackingLableUrl"
              :before-upload="handleBeforeUpload"
              :limit="1"
              :on-exceed="handlePackingLableUrlExceed"
              accept=".pdf"
          >
            <el-button type="primary">选择上传文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只允许上传pdf文件
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item  label="自发卡车BOL">
          <el-upload
              ref="truckBol"
              v-model:file-list="truckBol"
              class="upload-demo"
              :action="uploadUrl"
              :on-preview="handlePreview"
              :on-success="handleTruckBol"
              :before-upload="handleBeforeUpload"
              :limit="1"
              :on-exceed="handleTruckBolExceed"
              accept=".pdf"
          >
            <el-button type="primary">选择上传文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只允许上传pdf文件
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="formInline.sendChannel=='bby'"  label="同步Teapplix">
          <el-checkbox label="开启同步" v-model="formInline.isTp" />
        </el-form-item>
        <el-form-item  label="同步马帮">
          <el-checkbox label="开启同步" v-model="formInline.isMb" />
        </el-form-item>
        <div class="flex flex-row-right flex-item-center">
          <div>
            <el-button style="margin-right:10px"  type="danger" @click="submit(false)" >保存草稿</el-button>
            <el-button style="margin: 0 auto" type="primary" @click="submit(true)">保存并上传至RII</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
  ElUpload, ElMessage,genFileId,
  ElCheckbox
} from "element-plus";
import {addRIIModifyUpload, getChannel, getRIIModifyFile} from "@/utils/api";
import {uploadUrl} from "@/utils/requset"
export default {
  name: "addRIIFile",
  components:{
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElUpload,
    ElCheckbox
  },
  data(){
    return{
      dialogTableVisible:false,
      uploadUrl:"",
      formInline:{sendChannel:'bby',"riiNumber":"",isTp:true,isMb:true,trackNumber:'',channel:""},
      packingLableUrl:[],
      channelList:[],
      truckBol:[],
    }
  },
  beforeMount() {
    this.uploadUrl =uploadUrl
  },
  methods:{
    open(data,channel="bby"){
      this.dialogTableVisible=true;
      this.formInline.riiNumber = data.riiNumber
      this.formInline.sendChannel = channel
      this.formInline.trackNumber = data.trackNumber
      this.formInline.channel = ""
      this.getRIIModifyFile()
      if(channel=="bby"){
        this.formInline.isTp = true
      }else{
        this.loadData()
        this.formInline.isTp = false
      }
    },
    loadData(){
      getChannel({openFlag:1}).then(res=>{
        this.channelList = res.Data
      }).catch(err=>{
        console.log(err)
      })
    },
    getRIIModifyFile(){
      getRIIModifyFile({riiNumber:this.formInline.riiNumber}).then(res=>{
        console.log(res)
        this.packingLableUrl = res.Data.packingLableUrl;
        this.truckBol = res.Data.truckBol;
      }).catch(err=>{
        console.log(err)
      })
    },
    submit(mark){
      if(!this.formInline.trackNumber){
        ElMessage.warning('请输入卡派运单号')
        return
      }
      if(this.packingLableUrl.length==0){
        ElMessage.warning('请上传外箱贴文件')
        return
      }
      if(this.truckBol.length==0){
        ElMessage.warning('请上传自发卡车bol')
        return
      }
      if(this.formInline.sendChannel=="shopify"){
        if(!this.formInline.channel){
          ElMessage.warning('请选择物流渠道')
          return
        }
      }
      addRIIModifyUpload({
        riiNumber:this.formInline.riiNumber,
        trackNumber:this.formInline.trackNumber,
        truckBol:this.truckBol,
        sendChannel:this.formInline.sendChannel,
        channel:this.formInline.channel,
        packingLableUrl:this.packingLableUrl,
        isTp:this.formInline.isTp,
        isMb:this.formInline.isMb,
        isRii:mark
      }).then(res=>{
        this.dialogTableVisible = false
        this.$emit('close',res)
      }).catch(err=>{
        console.log(err)
      })
    },

    handlePackingLableUrl(response){
      this.packingLableUrl = [{name:response.filename,url:response.location}]
    },
    handleTruckBol(response){
      this.truckBol = [{name:response.filename,url:response.location}]
    },
    handlePackingLableUrlExceed(files){
      this.$refs.packingLableUrl.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      this.$refs.upload.handleStart(file);
    },
    handleTruckBolExceed(files){
      this.$refs.truckBol.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      this.$refs.upload.handleStart(file);
    },
    handleBeforeUpload(file){
      const fileExt = file.name.split('.').pop().toLowerCase();
      // 方法2：检查MIME类型（更可靠）
      const isPDF = file.type === 'application/pdf';

      if (fileExt !== 'pdf' || !isPDF) {
        ElMessage.error('只能上传PDF格式文件');
        return false;
      }
      return true;
    },
    handlePreview(file) {
      try {
        if (file.raw.type === "application/pdf") {
          const blob = new Blob([file.raw], {type: 'application/pdf'})
          window.open(URL.createObjectURL(blob), "_blank")
        }
      }catch (e) {
        const fileExt = file.name.split('.').pop().toLowerCase();
        if (fileExt=="pdf") {
          window.open(file.url, "_blank")
        }
      }
    }
  },


}
</script>
<style scoped>
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
::v-deep .el-form-item__label{
  width: 200px;
}

</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}
</style>